var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2647 7.69391C12.0811 7.97963 12.7205 8.4286 13.1831 9.04085C13.6457 9.63949 13.877 10.3674 13.877 11.2245C13.877 12.4762 13.3736 13.4422 12.3668 14.1225C11.36 14.8028 9.9042 15.1429 7.99944 15.1429H0.285156V0.857178H7.59128C9.41441 0.857178 10.8022 1.19731 11.7545 1.87759C12.7069 2.54425 13.1831 3.44901 13.1831 4.59187C13.1831 5.27214 13.013 5.88439 12.6729 6.42861C12.3464 6.95922 11.877 7.38099 11.2647 7.69391ZM4.28516 3.77554V6.53065H7.06067C8.42121 6.53065 9.10148 6.06806 9.10148 5.14289C9.10148 4.23133 8.42121 3.77554 7.06067 3.77554H4.28516ZM7.67291 12.2245C9.08788 12.2245 9.79536 11.7415 9.79536 10.7755C9.79536 9.80956 9.08788 9.32656 7.67291 9.32656H4.28516V12.2245H7.67291Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.124111676c50dd5fe843eb90a18fb24e.svg";
export { ForwardRef as ReactComponent };